import type { PrintingProfileDto } from "../../types/PrintingProfileDto";
import type { PrintingProfileEntity } from "../../types/PrintingProfileEntity";

export const PrintingProfileEntityToDto = ({ ...rest }: Readonly<PrintingProfileEntity>): PrintingProfileDto => {
    return { ...rest };
};
